import { gql, TypedDocumentNode } from "@apollo/client";

import {
  BitbucketCloudIntegration,
  MutationBitbucketCloudIntegrationCreateV2Args,
  MutationBitbucketCloudIntegrationUpdateV2Args,
  MutationBitbucketCloudIntegrationCreateArgs,
  MutationBitbucketCloudIntegrationUpdateArgs,
  MutationBitbucketCloudIntegrationDeleteArgs,
  Maybe,
} from "types/generated";

type CreateVCSBitbucketCloudIntegrationData = {
  bitbucketCloudIntegrationCreate: Pick<BitbucketCloudIntegration, "id" | "name">;
};

export const CREATE_BITBUCKET_CLOUD_INTEGRATION: TypedDocumentNode<
  CreateVCSBitbucketCloudIntegrationData,
  MutationBitbucketCloudIntegrationCreateArgs
> = gql`
  mutation CreateVCSBitbucketCloudIntegration(
    $appPassword: String!
    $customInput: CustomVCSInput!
    $username: String!
  ) {
    bitbucketCloudIntegrationCreate(
      appPassword: $appPassword
      customInput: $customInput
      username: $username
    ) {
      id
      name
    }
  }
`;

type CreateVCSBitbucketCloudIntegrationV2Data = {
  bitbucketCloudIntegrationCreateV2: Pick<BitbucketCloudIntegration, "id" | "name">;
};

export const CREATE_BITBUCKET_CLOUD_INTEGRATION_V2: TypedDocumentNode<
  CreateVCSBitbucketCloudIntegrationV2Data,
  MutationBitbucketCloudIntegrationCreateV2Args
> = gql`
  mutation CreateVCSBitbucketCloudIntegrationV2($input: BitbucketCloudIntegrationInput!) {
    bitbucketCloudIntegrationCreateV2(input: $input) {
      id
      name
    }
  }
`;

type UpdateVCSBitbucketCloudIntegrationData = {
  bitbucketCloudIntegrationUpdate: Pick<BitbucketCloudIntegration, "id" | "name">;
};

export const UPDATE_BITBUCKET_CLOUD_INTEGRATION: TypedDocumentNode<
  UpdateVCSBitbucketCloudIntegrationData,
  MutationBitbucketCloudIntegrationUpdateArgs
> = gql`
  mutation UpdateVCSBitbucketCloudIntegration(
    $appPassword: String
    $customInput: CustomVCSUpdateInput
    $username: String!
  ) {
    bitbucketCloudIntegrationUpdate(
      appPassword: $appPassword
      customInput: $customInput
      username: $username
    ) {
      id
      name
    }
  }
`;

type UpdateVCSBitbucketCloudIntegrationV2Data = {
  bitbucketCloudIntegrationUpdateV2: Pick<BitbucketCloudIntegration, "id" | "name">;
};

export const UPDATE_BITBUCKET_CLOUD_INTEGRATION_V2: TypedDocumentNode<
  UpdateVCSBitbucketCloudIntegrationV2Data,
  MutationBitbucketCloudIntegrationUpdateV2Args
> = gql`
  mutation UpdateVCSBitbucketCloudIntegrationV2($input: BitbucketCloudIntegrationUpdateInput!) {
    bitbucketCloudIntegrationUpdateV2(input: $input) {
      id
      name
    }
  }
`;

type BitbucketCloudIntegrationDeleteData = {
  bitbucketCloudIntegrationDelete: Pick<BitbucketCloudIntegration, "id" | "name">;
};

export const DELETE_BITBUCKET_CLOUD_INTEGRATION: TypedDocumentNode<
  BitbucketCloudIntegrationDeleteData,
  MutationBitbucketCloudIntegrationDeleteArgs
> = gql`
  mutation DeleteVCSBitbucketCloudIntegration($id: ID!) {
    bitbucketCloudIntegrationDelete(id: $id) {
      id
      name
    }
  }
`;

type CheckBitbucketCloudHasDefaultIntegrationData = {
  checkBitbucketCloudHasDefaultIntegration: Maybe<Pick<BitbucketCloudIntegration, "id">>;
};

export const CHECK_BITBUCKET_CLOUD_HAS_DEFAULT_INTEGRATION: TypedDocumentNode<CheckBitbucketCloudHasDefaultIntegrationData> = gql`
  query CheckVCSBitbucketCloudHasDefaultIntegration {
    checkBitbucketCloudHasDefaultIntegration: bitbucketCloudIntegration {
      id
    }
  }
`;
